var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgHamburger(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 22 17' }, props),
        React.createElement("rect", { width: 21.5, height: 1.5, x: 0.25, y: 0.75, rx: 0.75 }),
        React.createElement("rect", { width: 21.5, height: 1.5, x: 0.25, y: 14.75, rx: 0.75 }),
        React.createElement("rect", { width: 21.5, height: 1.5, x: 0.25, y: 7.75, rx: 0.75 })));
}
export default SvgHamburger;
//# sourceMappingURL=Hamburger.js.map